export type ShareOutcome = 'shared' | 'copied' | 'cancelled' | 'failed'

type ShareCapableNavigator = Pick<Navigator, 'clipboard'> & {
  share?: (data: ShareData) => Promise<void>
}

/**
 * Share a link with the Web Share API (phones: WhatsApp, Messages, …). When
 * it's unavailable (most desktops) or fails for a reason other than the user
 * dismissing the sheet, copy the link to the clipboard instead.
 */
export async function shareLink(
  url: string,
  nav: ShareCapableNavigator = navigator,
): Promise<ShareOutcome> {
  if (typeof nav.share === 'function') {
    try {
      await nav.share({ url })
      return 'shared'
    } catch (err) {
      if (err instanceof Error && err.name === 'AbortError') return 'cancelled'
      // Not allowed / unsupported payload: fall through to copy.
    }
  }
  try {
    await nav.clipboard.writeText(url)
    return 'copied'
  } catch {
    return 'failed'
  }
}
